module.exports = __webpack_public_path__ + "static/media/NW_error.0520dfe3.png";